export default {
  updateAll(state, value) {
    state.all = value
  },
  updateSingle(state, value) {
    state.single = value
  },
  updatePublishers(state, value) {
    state.publishers = value
  },
  updateTermLabels(state, value) {
    state.termLabels = value
  },
  updateTermStatuses(state, value) {
    state.termStatuses = value
  }
}
